import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "font-mono kbd kbd-sm bg-opacity-60 min-w-min whitespace-nowrap" }

import { assertUnreachable } from "@/utils";
import {
  isCondAlways,
  isCondLed,
  isCondUsbOn,
  isCondRole,
  isCondPressed,
  isCondKeyAction,
  isCondKeyPressed,
  isCondLayer,
  ConditionValue,
  isCondBootloaderAllowed,
} from "@/keyboard/leds";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionViewValue',
  props: {
    condition: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isCondAlways)(_ctx.condition))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode("Always")
        ], 64))
      : (_unref(isCondUsbOn)(_ctx.condition))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("USB ON")
          ], 64))
        : (_unref(isCondLed)(_ctx.condition))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(_ctx.condition.Led), 1)
            ], 64))
          : (_unref(isCondRole)(_ctx.condition))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(_toDisplayString(_ctx.condition.Role), 1)
              ], 64))
            : (_unref(isCondPressed)(_ctx.condition))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createTextVNode("Pressed")
                ], 64))
              : (_unref(isCondKeyAction)(_ctx.condition))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createTextVNode(_toDisplayString(_ctx.condition.KeyAction == "Trans" ? "Transparent" : _ctx.condition.KeyAction), 1)
                  ], 64))
                : (_unref(isCondKeyPressed)(_ctx.condition))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createTextVNode(" Pressed(" + _toDisplayString(_ctx.condition.KeyPressed[0]) + "," + _toDisplayString(_ctx.condition.KeyPressed[1]) + ") ", 1)
                    ], 64))
                  : (_unref(isCondLayer)(_ctx.condition))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                        _createTextVNode("Layer " + _toDisplayString(_ctx.condition.Layer), 1)
                      ], 64))
                    : (_unref(isCondBootloaderAllowed)(_ctx.condition))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                          _createTextVNode("Bootloader allowed")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                          _createTextVNode(_toDisplayString(_unref(assertUnreachable)(_ctx.condition)), 1)
                        ], 64))
  ]))
}
}

})